export default __webpack_public_path__ + "static/media/HenryChen.16025b77.png";